import type {PermissionTreeItem} from '../typedef';

type GetTreeCodes = (tree: PermissionTreeItem, codes?: string[]) => string[];
export const getTreeCodes: GetTreeCodes = (tree, codes = []) => {
    if (tree.code) {
        return [
            tree.code,
            ...tree.children.reduce<string[]>((acc, curr) => [
                ...acc,
                ...getTreeCodes(curr, codes),
            ], []),
        ];
    } else {
        return codes;
    }
};
